export default "{\n    \"activeCount_other\": \"{{count}} active skills\",\n    \"activeCount_one\": \"{{count}} active skill\"\n}\n"